// Define constants
const product_type_donation_tag = "donation_product";
const fastShippingGroupArray = [
  {
    "title": "Alternativegroup-0",
    "min_day": "0",
    "max_day": "1"
  },
  {
    "title": "Alternativegroup-1",
    "min_day": "0",
    "max_day": "2"
  },
  {
    "title": "Alternativegroup-2",
    "min_day": "3",
    "max_day": "5"
  },
]
const deliveryGroupArray = [
  {
    "title": "group-0",
    "min_day": "0",
    "max_day": "1"
  },
  {
    "title": "group-1",
    "min_day": "0",
    "max_day": "2"
  },
  {
    "title": "group-2",
    "min_day": "3",
    "max_day": "5"
  },
  {
    "title": "group-3",
    "min_day": "6",
    "max_day": "10"
  },
  {
    "title": "group-4",
    "min_day": "11",
    "max_day": "15"
  },
  {
    "title": "group-5",
    "min_day": "16",
    "max_day": "20"
  },
  {
    "title": "group-6",
    "min_day": "21",
    "max_day": "25"
  },
  {
    "title": "group-7",
    "min_day": "26",
    "max_day": "30"
  },
  {
    "title": "group-8",
    "min_day": "31",
    "max_day": "35"
  },
  {
    "title": "group-9",
    "min_day": "36",
    "max_day": "40"
  },
  {
    "title": "group-10",
    "min_day": "41",
    "max_day": "45"
  },
  {
    "title": "group-11",
    "min_day": "46",
    "max_day": "50"
  },
  {
    "title": "group-12",
    "min_day": "51",
    "max_day": "55"
  },
  {
    "title": "group-13",
    "min_day": "56",
    "max_day": "60"
  },
  {
    "title": "group-14",
    "min_day": "61",
    "max_day": "65"
  },
  {
    "title": "group-15",
    "min_day": "60",
    "max_day": "88"
  },
  {
    "title": "group-16",
    "min_day": "80",
    "max_day": "92"
  },
  {
    "title": "group-17",
    "min_day": "110",
    "max_day": "151"
  }
]
const expectedShipArray = [
  {
    "title": "expectedship-1",
    "day": "1"
  },
  {
    "title": "expectedship-2",
    "day": "2"
  },
  {
    "title": "expectedship-3",
    "day": "3"
  },
  {
    "title": "expectedship-4",
    "day": "4"
  },
  {
    "title": "expectedship-5",
    "day": "5"
  },
  {
    "title": "expectedship-6",
    "day": "6"
  },
  {
    "title": "expectedship-7",
    "day": "7"
  },
  {
    "title": "expectedship-9",
    "day": "9"
  },
  {
    "title": "expectedship-10",
    "day": "10"
  },
  {
    "title": "expectedship-14",
    "day": "14"
  },
  {
    "title": "expectedship-15",
    "day": "15"
  },
  {
    "title": "expectedship-17",
    "day": "17"
  },
  {
    "title": "expectedship-18",
    "day": "18"
  },
  {
    "title": "expectedship-20",
    "day": "20"
  },
  {
    "title": "expectedship-21",
    "day": "21"
  },
  {
    "title": "expectedship-24",
    "day": "24"
  },
  {
    "title": "expectedship-25",
    "day": "25"
  },
  {
    "title": "expectedship-30",
    "day": "30"
  },
  {
    "title": "expectedship-35",
    "day": "35"
  },
  {
    "title": "expectedship-38",
    "day": "38"
  },
  {
    "title": "expectedship-40",
    "day": "40"
  },
  {
    "title": "expectedship-50",
    "day": "50"
  },
];

// --- Expose shared data & helpers for reuse (e.g. wishlist ATC) ---
window.OlivelaDelivery = {
  deliveryGroupArray: deliveryGroupArray,
  expectedShipArray: expectedShipArray,
  /** Add business days (skip weekends) from a start date */
  addBusinessDays: function (startDate, numDays) {
    var d = new Date(startDate);
    for (var i = 0; i < numDays; i++) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() === 6) d.setDate(d.getDate() + 2);
      else if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    }
    return d;
  },
  /** Format a Date to "Thu May 29" or "Thu, May 29" */
  formatDate: function (d, withComma) {
    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    if (withComma) return days[d.getDay()] + ', ' + months[d.getMonth()] + ' ' + d.getDate();
    return days[d.getDay()] + ' ' + months[d.getMonth()] + ' ' + d.getDate();
  },
  /**
   * Compute line-item delivery properties from an array of product tags
   * @param {string[]} tags
   * @param {number} [leadTime]
   * @param {number} [carrierMin]
   * @param {number} [carrierMax]
   * @param {boolean} [isFastShipping]
   */
  computeDeliveryProps: function (tags, leadTime, carrierMin, carrierMax, isFastShipping) {
    leadTime = leadTime || 0;
    carrierMin = carrierMin != null ? carrierMin : 3;
    carrierMax = carrierMax != null ? carrierMax : 4;
    var self = window.OlivelaDelivery;
    var today = new Date();
    var props = { '_estimate': '', '_expected-ship': '', '_item_delivery_group': '', '_item_expected_ship': '' };

    if (isFastShipping) {
      var altGroup = fastShippingGroupArray[0];
      props['_item_delivery_group'] = altGroup ? altGroup.title : '';
      var altMinD = self.addBusinessDays(today, parseInt(altGroup ? altGroup.min_day : '0') + carrierMin + leadTime);
      var altMaxD = self.addBusinessDays(today, parseInt(altGroup ? altGroup.max_day : '1') + carrierMax + leadTime);
      props['_estimate'] = 'Estimated delivery ' + self.formatDate(altMinD, false) + ' - ' + self.formatDate(altMaxD, false);
    } else {
      // Find delivery group tag
      for (var i = 0; i < self.deliveryGroupArray.length; i++) {
        if (tags.indexOf(self.deliveryGroupArray[i].title) !== -1) {
          var g = self.deliveryGroupArray[i];
          props['_item_delivery_group'] = g.title;
          var minD = self.addBusinessDays(today, parseInt(g.min_day) + carrierMin + leadTime);
          var maxD = self.addBusinessDays(today, parseInt(g.max_day) + carrierMax + leadTime);
          props['_estimate'] = 'Estimated delivery ' + self.formatDate(minD, false) + ' - ' + self.formatDate(maxD, false);
          break;
        }
      }
    }

    // Find expected ship tag
    for (var j = 0; j < self.expectedShipArray.length; j++) {
      if (tags.indexOf(self.expectedShipArray[j].title) !== -1) {
        var s = self.expectedShipArray[j];
        props['_item_expected_ship'] = s.title;
        var shipDate = self.addBusinessDays(today, parseInt(s.day) + leadTime);
        props['_expected-ship'] = self.formatDate(shipDate, true);
        break;
      }
    }
    return props;
  }
};

// True when the given (or currently selected) variant is a "Fast shipping" (Local) variant.
// Tests the variant id against the static list of this product's fast-shipping variant IDs
// — avoids relying on option-value radios' data-fast-shipping attributes, which can go stale
// on fieldsets the variant-picker morph doesn't fully re-render after an unrelated option
// changes.
//
// With no argument it falls back to the hidden variant-id input's own current value, which
// product-form.js keeps in sync. Pass variantId to evaluate a specific variant instead: the
// hidden input is only written from `variant:update`, which fires after the variant-picker's
// section-rendering fetch resolves, so during the optimistic `variant:selected` pass the
// input still holds the *previous* variant.
/** @param {string} [variantId] */
function isFastShippingSelected(variantId) {
  // Other buy-buttons instances can exist on the same page (e.g. a product
  // recommendations carousel), each with their own hidden id input — exclude
  // those so we only ever read the actual PDP's own product form, matching the
  // same product-card/quick-add-dialog exclusion used elsewhere in the theme
  // (see the isOnProductPage check in variant-picker.js).
  const candidates = document.querySelectorAll('input[name="id"][data-fast-shipping-variant-ids]');
  const variantIdInput = /** @type {HTMLInputElement | undefined} */ (
    Array.from(candidates).find((el) => !el.closest('product-card') && !el.closest('quick-add-dialog'))
  );
  if (!variantIdInput) return false;
  const fastShippingIds = variantIdInput.dataset.fastShippingVariantIds?.split(',').filter(Boolean) || [];
  return fastShippingIds.includes(variantId || variantIdInput.value);
}

document.addEventListener('DOMContentLoaded', () => {
  /** @param {string} [variantId] Optional variant id to evaluate instead of the hidden input's value */
  const renderEstimatedDatesPlaceholders = (variantId) => {
    // Select all estimated-dates placeholders
    const placeholders = document.querySelectorAll('.estimated-dates-placeholder');
    const fastShipping = isFastShippingSelected(variantId);

    placeholders.forEach(placeholder => {
      // Extract data attributes
      const leadTime = parseInt(placeholder.getAttribute('data-lead-time')) || 0;
      const carrierMin = parseInt(placeholder.getAttribute('data-carrier-min')) || 3;
      const carrierMax = parseInt(placeholder.getAttribute('data-carrier-max')) || 4;
      const tags = placeholder.getAttribute('data-product-tags')?.split(',') || [];
      // Several placeholders can exist on one page (main PDP block + the Standard/
      // Express/International options inside the Delivery & Returns drawer). Only
      // the primary one represents the estimate actually used for the order, so
      // only it should write cart line-item properties — the drawer entries are
      // informational only and must not overwrite those properties.
      const isPrimary = placeholder.getAttribute('data-primary') === 'true';
  
      // Utility functions
      const getDateFromNow = (day, withComma = false) => {
        // OS-6099: Days array for formatting date output
        // Eg of estimated dates: Thu May 29 - Tue Jun 03
        let days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        let today = new Date();
    
        // Use countWeekendDays to calculate the new date
        let newDate = countWeekendDays(today, day);
        
        if(withComma) {
          return `${days[newDate.getDay()]}, ${months[newDate.getMonth()]} ${newDate.getDate()}`;
        }else{
          return `${days[newDate.getDay()]} ${months[newDate.getMonth()]} ${newDate.getDate()}`;
        }
      };
      
      const countWeekendDays = (d0, days) => {
        for (let i = 0; i < days; i++) {
          d0 = addDays(d0, 1);
          if (d0.getDay() === 6) {
            d0 = addDays(d0, 2); // Skip Saturday and Sunday
          } else if (d0.getDay() === 0) {
            d0 = addDays(d0, 1); // Skip Sunday
          }
        }
        return d0;
      };
      
      const addDays = (myDay, no) => {
        return new Date(
          myDay.getFullYear(),
          myDay.getMonth(),
          myDay.getDate() + parseInt(no)
        );
      };
  
      // Calculate Ship Date
      const calculateShipDate = () => {
        if (tags.includes(product_type_donation_tag)) {
          return null; // Skip donation products
        }
        const findShipDays = expectedShipArray.find(group => tags.includes(group.title));
        if (!findShipDays) {
          return null;
        }
        let shipDays = parseInt(findShipDays.day) + leadTime;
        return getDateFromNow(shipDays, true);
      };
  
      // Calculate Delivery Date
      const calculateDeliveryDate = () => {
        if (tags.includes(product_type_donation_tag)) {
          return null; // Skip donation products
        }
        const findGroup = fastShipping ? fastShippingGroupArray[0] : deliveryGroupArray.find(group => tags.includes(group.title));
        if (!findGroup) {
          return null;
        }
        let minDate = parseInt(findGroup.min_day) + carrierMin + leadTime;
        let maxDate = parseInt(findGroup.max_day) + carrierMax + leadTime;
        return `${getDateFromNow(minDate)} - ${getDateFromNow(maxDate)}`;
      };
  
      // Get Ship Date and Delivery Date
      const shipDate = calculateShipDate();
      const deliveryDate = calculateDeliveryDate();
      
  
      // Inject the calculated dates into the placeholder
      if (shipDate || deliveryDate) {
        placeholder.innerHTML = `${deliveryDate ? `<p>Estimated delivery ${deliveryDate}</p>` : ''}
        `;
      } else {
        placeholder.innerHTML = `<p>Shipping information is not available.</p>`;
      }

      // Always sync hidden cart-form inputs for the primary placeholder — even when
      // there's no matching delivery info (deliveryDate/shipDate are '') — so that
      // switching away from a fast-shipping/tagged variant actively clears out the
      // previous variant's stale values instead of leaving them in place.
      if (isPrimary) {
        const params = {
          deliveryDate: deliveryDate || '',
          shipDate: shipDate || '',
          itemDeliveryGroup: fastShipping
            ? (fastShippingGroupArray[0]?.title || '')
            : (tags.find(tag => deliveryGroupArray.some(group => group.title === tag)) || ''),
          itemExpectedShip: tags.find(tag => expectedShipArray.some(group => group.title === tag)) || '',
        };
        window.addHiddenInputsToCartForm(params);
      }
    });
  };

  // Initial render on page load
  renderEstimatedDatesPlaceholders();

  // Render optimistically the moment an option is clicked. `variant:selected` fires
  // synchronously from variant-picker.js, whereas `variant:update` only fires once the
  // section-rendering fetch resolves — waiting on that round-trip left the estimate
  // showing the previous variant's dates for the duration of the request (and longer
  // still while switching quickly, since each new click aborts the in-flight fetch and
  // an aborted request dispatches no `variant:update` at all).
  document.addEventListener('variant:selected', (event) => {
    // Pickers inside a product card / quick-add dialog belong to a different product —
    // their variant id must never be applied to this PDP's placeholders. Matches the
    // exclusion used in isFastShippingSelected() and variant-picker.js's isOnProductPage.
    const { target } = event;
    if (target instanceof Element && (target.closest('product-card') || target.closest('quick-add-dialog'))) return;

    // Absent for combined-listing switches, where the whole product changes — those are
    // left to the variant:update pass below, which runs once the new product has morphed in.
    const variantId = /** @type {any} */ (event).detail?.resource?.variantId;
    if (!variantId) return;

    renderEstimatedDatesPlaceholders(variantId);
  });

  // Re-render whenever the customer switches variants (fast-shipping status may change).
  // Still needed after the optimistic pass above: it reconciles against the authoritative
  // post-fetch state and covers cases the optimistic path skips (no resolvable variant id,
  // or a re-render triggered by newly morphed placeholder data attributes).
  document.addEventListener('variant:update', () => {
    renderEstimatedDatesPlaceholders();
  });

  const updateCartProperties = () => {
      return fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const updates = cart.items.map(item => {
            //skip gift card items
            if (item.gift_card) {
              return null;
            }
            // Use _item_delivery_group and _item_expected_ship instead of tags
            const deliveryGroup = item.properties?._item_delivery_group || '';
            const expectedShip = item.properties?._item_expected_ship || '';
            const isFastShippingItem = deliveryGroup === (fastShippingGroupArray[0]?.title || '');
            const leadTime = parseInt(item.properties?.['lead_time']) || 0;
            // Engraving/personalization adds its own lead time on top of the
            // product's base lead_time, via a dedicated property so it never
            // collides with (or gets confused for) the base lead_time value.
            const engravingLeadTime = parseInt(item.properties?.['_engraving_lead_time']) || 0;
            const totalLeadTime = leadTime + engravingLeadTime;
            const carrierMin = parseInt(item.properties?.['carrier_min']) || 3;
            const carrierMax = parseInt(item.properties?.['carrier_max']) || 4;

            // Recalculate dates
            const newShipDate = calculateShipDate([expectedShip], totalLeadTime); // Pass as an array
            const newDeliveryDate = calculateDeliveryDate([deliveryGroup], totalLeadTime, carrierMin, carrierMax, isFastShippingItem); // Pass as an array
            
            // Get existing dates from properties
            const existingShipDate = item.properties?.['_expected-ship'] || '';
            const existingDeliveryDate = item.properties?._estimate || '';
    
            // Check if updates are needed
            if (
              existingShipDate === newShipDate &&
              existingDeliveryDate === `Estimated delivery ${newDeliveryDate}`
            ) {
              // No update needed, return null
              return null;
            }
    
            // Update properties if dates are different
            return {
              id: item.id,
              key: item.key,
              quantity: item.quantity,
              properties: {
                ...item.properties,
                _estimate: `Estimated delivery ${newDeliveryDate}`,
                // calculateShipDate returns null when no expected-ship tag
                // matches — sending JS null through as a cart property gets
                // stored as the literal string "null", so fall back to ''.
                '_expected-ship': newShipDate || '',
              },
            };
          });
    
          // Filter out items that don't need updates
          const filteredUpdates = updates.filter(update => update !== null);

          if (filteredUpdates.length === 0) return;
    
          // Send updates to Shopify sequentially to avoid race conditions
          // (parallel calls with line indices cause wrong items to update)
          const updateSequentially = async () => {
            for (const update of filteredUpdates) {
              try {
                const response = await fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    'id': update.key,
                    'quantity': update.quantity,
                    'properties': update.properties
                  }),
                });
                await response.json();
                // Update the cart UI immediately for this item
                updateDeliveryDatesInCartUI(update.id, update.properties._estimate);
              } catch (error) {
                console.error('Error updating cart delivery date:', error);
              }
            }
          };
          return updateSequentially();
        });
    };

    // Function to update the cart UI with new dates
    const updateDeliveryDatesInCartUI = (itemId, newEstimatedDeliveryDate) => {
      // Get existing DOM elements for this item
      const cartItemElement = document.querySelector(`.cart-items__table-row[data-id="${itemId}"]`);
      if (cartItemElement) {
        const deliveryDateElement = cartItemElement.querySelector('.cart-items-delivery-date');

        // Update only if the dates have changed
        if (deliveryDateElement) {
          const isInDrawer = !!deliveryDateElement.closest('#cart-drawer-cart-col');
          let displayDate = newEstimatedDeliveryDate || 'N/A';
          if (isInDrawer && newEstimatedDeliveryDate) {
            displayDate = newEstimatedDeliveryDate
              .replace(/\b(Mon|Tue|Tues?|Wed|Thurs?|Thu|Fri|Sat|Sun)\s/g, '');
          }
          deliveryDateElement.textContent = displayDate;
        }
      }
    };

    // Utility functions (reuse from your existing logic)
    const calculateShipDate = (tags, leadTime) => {
      const findShipDays = expectedShipArray.find(group => tags.includes(group.title));
      if (!findShipDays) return null;
      const shipDays = parseInt(findShipDays.day) + leadTime;
      return getDateFromNow(shipDays, true);
    };
  
    /** @param {boolean} [isFastShipping] */
    const calculateDeliveryDate = (tags, leadTime, carrierMin, carrierMax, isFastShipping) => {
      const findGroup = isFastShipping ? fastShippingGroupArray[0] : deliveryGroupArray.find(group => tags.includes(group.title));
      if (!findGroup) return null;
      const minDate = parseInt(findGroup.min_day) + carrierMin + leadTime;
      const maxDate = parseInt(findGroup.max_day) + carrierMax + leadTime;
      return `${getDateFromNow(minDate)} - ${getDateFromNow(maxDate)}`;
    };
  
    const getDateFromNow = (day, withComma = false) => {
      const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      let today = new Date();
  
      while (day > 0) {
        today.setDate(today.getDate() + 1);
        const dayOfWeek = today.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          day--;
        }
      }
  
      return withComma
        ? `${days[today.getDay()]}, ${months[today.getMonth()]} ${today.getDate()}`
        : `${days[today.getDay()]} ${months[today.getMonth()]} ${today.getDate()}`;
    };
    
    
    // Re-entrancy guard – prevents overlapping updateCartProperties calls
    // (our own /cart/change.js fetches can trigger cart:update too)
    let isUpdatingCart = false;

    const runUpdate = (delay = 0) => {
      if (isUpdatingCart) return;
      isUpdatingCart = true;
      setTimeout(() => {
        updateCartProperties().finally(() => {
          isUpdatingCart = false;
        });
      }, delay);
    };

    // 1. Recalculate delivery dates when the cart page loads
    if (window.location.pathname.includes('/cart')) {
      runUpdate();
    }

    // 2. Run after any cart quantity change / section morph
    //    (cart:update is dispatched by CartAddEvent / CartUpdateEvent)
    document.addEventListener('cart:update', () => {
      // Small delay to let the section HTML morph complete before we patch the DOM
      runUpdate(300);
    });

    // Expose for external callers
    window.updateCartDeliveryDates = updateCartProperties;
  });